<template>
  <div class="press-card">
    <div
      v-if="pressRelease.image"
      class="press-card__image">
      <b-img-lazy
        :src="`${pressRelease.image}?impolicy=Card`"
        crossorigin="anonymous"
        :alt="pressRelease.title"
        class="container-card-press-release__img img-responsive" />
    </div>
    <div class="press-card__body">
      <a
        v-if="pressRelease.detailPage || pressRelease.pdfUrl"
        class="press-card__link"
        :rel="!pressRelease.detailPage && pressRelease.pdfUrl ? 'noopener noreferrer' : ''"
        :aria-label="pressRelease.title"
        :target="!pressRelease.detailPage && pressRelease.pdfUrl ? '_blank' : false"
        :href="pressRelease.detailPage || pressRelease.pdfUrl"
        @click="handleLinkClick">
      </a>
      <p class="date">{{ getFriendlyDate() }}</p>
      <div v-if="pressRelease.topics && !isMobile" class="tag-container">
        <Tag
          :key="index"
          v-for="(tag, index) in getTags.slice(0, getMaxTopics)"
          :tag="tag"
          :isSelected="isTagSelected(tag)"/>
        <Tag
          v-if="getTags.length > getMaxTopics && !isMobile"
          tag="+"/>
      </div>
      <h3 class="title">{{ pressRelease.title }}</h3>
      <p v-if="pressRelease.description && !isMobile" class="description">{{ pressRelease.description }}</p>
    </div>
    <hr v-if="isMobile && hasSeparator" class="separator"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { DateFactory } from 'rhg-vue-common'
import Tag from '@/components/Tag'
import { maxTopics } from '@/infrastructure/Configuration'

export default {
  name: 'PressRelease',
  data: () => {
    return {
      maxTopics
    }
  },
  components: {
    Tag
  },
  props: {
    pressRelease: Object,
    isMobile: Boolean,
    hasSeparator: Boolean
  },
  methods: {
    getFriendlyDate () {
      return DateFactory.formatDate(this.pressRelease.date, DateFactory.DatePatterns[`CORPORATE${this.pressRelease.showDay ? '' : '_NO_DATE'}`])
    },
    isTagSelected (tag) {
      return tag === this.getSelectedTopic.name
    },
    handleLinkClick () {
      sessionStorage.setItem('scroll-position', document.documentElement.scrollTop)
      sessionStorage.setItem('pagination', JSON.stringify(this.pagination))
    }
  },
  computed: {
    ...mapState(['topics', 'pagination']),
    ...mapGetters(['getSelectedTopic', 'areFiltersSelected']),
    getMaxTopics () {
      return this.isMobile ? 1 : this.maxTopics
    },
    getTags () {
      const tags = this.pressRelease.topics
        .map((topic) => this.topics[topic] && this.topics[topic].name)
        .filter(Boolean)

      if (this.areFiltersSelected && tags.includes(this.getSelectedTopic.name)) {
        return tags.reduce((acc, curr) => this.isTagSelected(curr) ? acc : [...acc, curr], [this.getSelectedTopic.name])
      }
      return tags
    }
  }
}
</script>

<style lang="scss" scoped>
  .press-card {
    display: flex;
    margin: 28px 0;
    flex-direction: column;
    position: relative;

    .separator {
      margin: 0;
      height: 3px;
      border: none;
      background-color: #E0E0E0;
      opacity: 1;
      position: absolute;
      bottom: -28px;
      right: 0;
      left: 0;
    }

    &__link {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      &:hover ~ .title {
        text-decoration: underline;
      }

    }

    &__image {
      width: 100%;
      margin-right: 0;
      height: 172px;
      flex-shrink: 0;
      border-radius: 8px;
      overflow: hidden;
      img {
        height: 100%;
      }
    }

    &__body {
      flex-grow: 1;
      margin-top: 20px;

      .date {
        margin: 0;
        margin-bottom: 8px;
        font-size: 12px;
        font-weight: 500;
        color: #737373;
      }

      .tag-container {
        display: flex;
        flex-wrap: wrap;
        row-gap: 12px;
        margin-bottom: 8px;
      }

      .title {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 10px;
        line-height: 28px;
      }

      .description {
        font-size: 16px;
        line-height: 24px;
        width: 100%;
        max-height: 48px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin: 0;
      }
    }
  }

  @media screen and (min-width: 991px) {
    .press-card {
      flex-direction: row;

      &__image {
        width: 290px;
        margin-right: 30px;
      }

      &__body {
        margin-top: 0;

        .title {
          width: 100%;
          max-height: 56px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
  }

  @media screen and (max-width: 991px) {
    .title ~ .press-card {
      &:first-of-type {
        margin-top: 10px;
      }
    }
  }

</style>
